<rid-demo-page [title]="'Morfemen'" previousRoute="/mechanics">
  <rid-button class="w-full" content="Kortste vorm herkennen" variant="PRIMARY" routerLink="recognize-shortest-form" />
  <rid-button class="w-full" content="Woordenslang" variant="PRIMARY" routerLink="word-snake" />
  <rid-button class="w-full" content="Woordbouwen" variant="PRIMARY" routerLink="word-building" />
</rid-demo-page>
